export default "__VITE_ASSET__Csuc4vr8__"